export const categories = [
  {
    id: 'xinwen',
    name: '新闻资讯',
    slug: 'xinwen',
    icon: 'ri-newspaper-line',
    description: '实时新闻、时事热点、深度报道，掌握最新传媒动态',
    color: 'primary',
  },
  {
    id: 'zongyi',
    name: '综艺娱乐',
    slug: 'zongyi',
    icon: 'ri-emotion-happy-line',
    description: '热门综艺、娱乐节目、真人秀，放松身心的最佳选择',
    color: 'accent',
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    icon: 'ri-film-line',
    description: '自然、历史、人文、科技纪录片，探索世界奥秘',
    color: 'secondary',
  },
  {
    id: 'yingshi',
    name: '影视剧场',
    slug: 'yingshi',
    icon: 'ri-movie-2-line',
    description: '经典电影、热门剧集、独家策划，精彩不间断',
    color: 'primary',
  },
  {
    id: 'tiyu',
    name: '体育赛事',
    slug: 'tiyu',
    icon: 'ri-basketball-line',
    description: '全球体育赛事直播与回看，激情与荣耀的见证',
    color: 'accent',
  },
  {
    id: 'jiaoyu',
    name: '教育文化',
    slug: 'jiaoyu',
    icon: 'ri-book-open-line',
    description: '在线课堂、文化讲座、知识分享，终身学习平台',
    color: 'secondary',
  },
];

export const channels = [
  {
    id: 'cctv-1',
    name: 'CCTV-1 综合',
    logo: 'ri-tv-line',
    isLive: true,
    currentProgram: '新闻联播',
    viewers: 1258000,
  },
  {
    id: 'cctv-news',
    name: 'CCTV-13 新闻',
    logo: 'ri-tv-2-line',
    isLive: true,
    currentProgram: '朝闻天下',
    viewers: 892000,
  },
  {
    id: 'hunan-tv',
    name: '湖南卫视',
    logo: 'ri-live-line',
    isLive: true,
    currentProgram: '快乐大本营精选',
    viewers: 1560000,
  },
  {
    id: 'zhejiang-tv',
    name: '浙江卫视',
    logo: 'ri-broadcast-line',
    isLive: true,
    currentProgram: '奔跑吧',
    viewers: 980000,
  },
  {
    id: 'dongfang-tv',
    name: '东方卫视',
    logo: 'ri-signal-tower-line',
    isLive: false,
    currentProgram: '极限挑战回看',
    viewers: 0,
  },
  {
    id: 'jiangsu-tv',
    name: '江苏卫视',
    logo: 'ri-radio-line',
    isLive: true,
    currentProgram: '非诚勿扰',
    viewers: 720000,
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '2026年度传媒行业十大发展趋势深度解析',
    category: 'xinwen',
    categoryName: '新闻资讯',
    excerpt: '随着人工智能、5G、虚拟现实等技术的不断成熟，传媒行业正迎来前所未有的变革期。本文深度解析2026年传媒行业的十大关键趋势，从内容生产、分发渠道到用户体验，全方位剖析未来发展方向。',
    content: `<p>随着人工智能、5G、虚拟现实等技术的不断成熟，传媒行业正迎来前所未有的变革期。本文深度解析2026年传媒行业的十大关键趋势。</p>
    <h2>一、AI驱动的内容生产革命</h2>
    <p>人工智能技术在内容创作领域的应用日益广泛，从智能剪辑、自动字幕生成到AI辅助写作，传媒内容的生产效率得到极大提升。据统计，2026年已有超过60%的传媒机构采用AI工具辅助日常内容生产。</p>
    <p>传媒在线观看平台率先引入AI智能推荐系统，根据用户观看习惯精准推送个性化内容，让每一位用户都能找到自己喜爱的节目。</p>
    <h2>二、超高清内容成为主流</h2>
    <p>4K/8K超高清视频逐渐成为行业标准。传媒在线观看平台全面支持高清甚至超高清画质播放，为用户带来影院级的视听体验。无论是在手机、平板还是大屏幕电视上，都能享受清晰流畅的观看体验。</p>
    <h2>三、互动式直播体验升级</h2>
    <p>直播不再是单向的内容输出。弹幕互动、实时投票、连线互动等功能让观众深度参与到节目中。传媒在线观看的直播频道全面支持多维度互动功能，拉近主播与观众的距离。</p>
    <p>展望未来，传媒在线观看将继续深耕技术创新，为用户提供更加丰富多元的高清视频内容和服务。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20media%20broadcast%20studio%20with%20multiple%20screens%20displaying%20news%20and%20data%20visualization%2C%20futuristic%20technology%20theme%2C%20warm%20ambient%20lighting%2C%20professional%20broadcast%20environment%2C%20clean%20aesthetic%2C%20high%20detail%20editorial%20photography&width=1200&height=675&seq=article-trend-01&orientation=landscape',
    date: '2026-08-05',
    author: '传媒观察',
    views: 15680,
    tags: ['行业趋势', 'AI技术', '超高清'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '《星光大道》2026全新赛季重磅回归，赛制全面升级',
    category: 'zongyi',
    categoryName: '综艺娱乐',
    excerpt: '备受观众喜爱的综艺节目《星光大道》2026全新赛季即将在传媒在线观看平台独家首播。新赛季不仅选手阵容更加强大，赛制也进行了全面升级，引入全新的评分机制和观众互动方式。',
    content: `<p>备受观众喜爱的综艺节目《星光大道》2026全新赛季即将在传媒在线观看平台独家首播。新赛季不仅选手阵容更加强大，赛制也进行了全面升级。</p>
    <h2>全新赛制亮点</h2>
    <p>本赛季首次引入"观众实时评分"系统，观众可以通过传媒在线观看平台直接为自己喜爱的选手投票，投票结果将实时影响选手的晋级命运。这一创新机制让观众不再只是旁观者，而是节目真正的参与者。</p>
    <h2>明星导师阵容</h2>
    <p>新赛季邀请了华语乐坛四位顶级歌手担任导师，每位导师都将带领自己的战队，通过多轮比拼争夺最终的冠军荣誉。导师之间的互动也将成为本季节目的重要看点。</p>
    <p>传媒在线观看平台将提供全程高清直播和点播回看服务，错过直播的观众可以随时通过点播功能重温精彩瞬间。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Grand%20stage%20performance%20with%20colorful%20lighting%20and%20spotlights%2C%20talent%20show%20atmosphere%2C%20dramatic%20stage%20design%20with%20golden%20and%20warm%20tones%2C%20entertainment%20show%20production%2C%20high%20energy%20vibrant%20scene&width=1200&height=675&seq=article-show-02&orientation=landscape',
    date: '2026-08-04',
    author: '综艺快报',
    views: 23450,
    tags: ['综艺', '星光大道', '赛季回归'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '《地球脉动 III》独家上线：探秘地球上最后的荒野秘境',
    category: 'jilupian',
    categoryName: '纪录片',
    excerpt: 'BBC年度纪录片巨制《地球脉动 III》正式登陆传媒在线观看平台。这部历时五年拍摄的自然纪录片，深入地球上最偏远、最壮美的角落，用镜头记录下令人叹为观止的自然奇观。',
    content: `<p>BBC年度纪录片巨制《地球脉动 III》正式登陆传媒在线观看平台。这部历时五年拍摄的自然纪录片，深入地球上最偏远、最壮美的角落。</p>
    <h2>五年磨一剑</h2>
    <p>制作团队跨越七大洲、四十余个国家，运用最新的8K超高清摄影技术和无人机航拍手段，捕捉到许多此前从未被镜头记录过的珍稀动物行为和自然景观。从亚马逊雨林深处到南极冰川，从撒哈拉沙漠到太平洋深海，每一帧画面都令人叹为观止。</p>
    <h2>中文独家配音</h2>
    <p>传媒在线观看平台特别邀请了知名配音演员为中文版进行专业配音，让观众在感受视觉震撼的同时，也能通过生动的解说深入了解每一个自然故事背后的科学知识。</p>
    <p>全系列共八集，每周更新两集，传媒在线观看平台会员可抢先观看完整系列。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20pristine%20wilderness%20with%20snow%20capped%20mountains%20and%20crystal%20clear%20lake%2C%20golden%20sunset%20light%2C%20nature%20documentary%20cinematography%20style%2C%20breathtaking%20vista%2C%20warm%20earth%20tones&width=1200&height=675&seq=article-nature-03&orientation=landscape',
    date: '2026-08-03',
    author: '纪录片频道',
    views: 31200,
    tags: ['纪录片', '自然', 'BBC'],
    featured: true,
  },
  {
    id: 'article-4',
    title: '《长安十二时辰》精编版上线，重温大唐盛世风华',
    category: 'yingshi',
    categoryName: '影视剧场',
    excerpt: '备受好评的古装剧《长安十二时辰》精编版正式登陆传媒在线观看平台。精编版在保留原剧精华的基础上，进行了节奏优化和画质提升，为观众带来更加紧凑流畅的观剧体验。',
    content: `<p>备受好评的古装剧《长安十二时辰》精编版正式登陆传媒在线观看平台。精编版在保留原剧精华的基础上，进行了节奏优化和画质提升。</p>
    <h2>精编版的亮点</h2>
    <p>精编版将原剧48集的内容提炼为24集，删减了部分支线剧情，聚焦主线故事，让观众能够更加沉浸式地体验大唐盛世的恢弘画卷。同时，画面经过了4K重制处理，服饰细节、建筑风貌都更加清晰动人。</p>
    <h2>文化价值</h2>
    <p>该剧不仅是一部精彩的悬疑剧，更是一幅展现唐代社会风貌的历史画卷。从服饰礼仪到饮食文化，从建筑艺术到诗词歌赋，处处体现着中国传统文化的深厚底蕴。</p>
    <p>传媒在线观看平台同步上线了《长安十二时辰》幕后制作特辑，揭秘剧中那些令人惊艳的场景是如何打造而成的。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%20at%20dusk%20with%20traditional%20architecture%20and%20lanterns%2C%20atmospheric%20warm%20golden%20lighting%2C%20historical%20drama%20cinematic%20style%2C%20majestic%20palace%20silhouette&width=1200&height=675&seq=article-drama-04&orientation=landscape',
    date: '2026-08-02',
    author: '影视推荐',
    views: 18900,
    tags: ['影视剧', '古装', '精编版'],
    featured: false,
  },
  {
    id: 'article-5',
    title: '2026年巴黎奥运会倒计时：传媒在线观看全程直播计划公布',
    category: 'tiyu',
    categoryName: '体育赛事',
    excerpt: '距离2026年巴黎奥运会开幕还有不到一年时间，传媒在线观看平台正式公布了奥运会全程直播计划。平台将提供全部32个大项、329个小项的高清直播服务，并配备专业中文解说团队。',
    content: `<p>距离2026年巴黎奥运会开幕还有不到一年时间，传媒在线观看平台正式公布了奥运会全程直播计划。</p>
    <h2>全项目覆盖</h2>
    <p>平台将提供全部32个大项、329个小项的高清直播服务。从田径、游泳等传统热门项目到攀岩、滑板等新增项目，观众都可以通过传媒在线观看平台实时观看比赛盛况。</p>
    <h2>专业解说阵容</h2>
    <p>传媒在线观看邀请了包括前奥运冠军、资深体育评论员在内的强大解说团队，为观众带来专业、深入的赛事分析和解说。多路信号同时直播，观众可以自由选择关注的比赛项目。</p>
    <p>此外，平台还将推出"奥运记忆"专题频道，回顾历届奥运会的经典瞬间和高光时刻。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Olympic%20stadium%20with%20dramatic%20opening%20ceremony%20fireworks%20and%20light%20shows%2C%20grand%20sports%20arena%20atmosphere%2C%20international%20sports%20event%2C%20warm%20evening%20sky%20with%20colorful%20displays%2C%20spectacular%20celebration&width=1200&height=675&seq=article-olympic-05&orientation=landscape',
    date: '2026-08-01',
    author: '体育频道',
    views: 45600,
    tags: ['奥运会', '体育直播', '巴黎'],
    featured: true,
  },
  {
    id: 'article-6',
    title: '在线教育新趋势：传媒在线观看推出"名师讲堂"系列课程',
    category: 'jiaoyu',
    categoryName: '教育文化',
    excerpt: '传媒在线观看平台全新推出"名师讲堂"系列在线课程，邀请全国知名教育专家和一线名师，打造涵盖K12教育、职业培训、人文素养等多个领域的精品课程内容。',
    content: `<p>传媒在线观看平台全新推出"名师讲堂"系列在线课程，邀请全国知名教育专家和一线名师打造精品课程。</p>
    <h2>课程体系</h2>
    <p>"名师讲堂"涵盖K12教育、职业培训、人文素养、艺术鉴赏等多个领域。每门课程都经过精心设计，融合了先进的教学理念和丰富的实战经验，帮助学生和职场人士高效提升自身能力。</p>
    <h2>高清互动课堂</h2>
    <p>所有课程均采用高清录制，支持在线互动答疑。学员可以在观看课程的同时通过弹幕和评论区与老师实时交流。传媒在线观看平台的回看功能让错过直播的学员可以随时补课。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20online%20education%20classroom%20with%20large%20digital%20screen%20displaying%20educational%20content%2C%20warm%20inviting%20learning%20environment%2C%20bright%20natural%20light%2C%20clean%20minimalist%20design%2C%20knowledge%20sharing%20atmosphere&width=1200&height=675&seq=article-edu-06&orientation=landscape',
    date: '2026-07-30',
    author: '教育频道',
    views: 8900,
    tags: ['在线教育', '名师讲堂', '课程'],
    featured: false,
  },
  {
    id: 'article-7',
    title: '传媒在线观看月活用户突破5000万，领跑中文视频平台',
    category: 'xinwen',
    categoryName: '新闻资讯',
    excerpt: '传媒在线观看平台宣布，截至2026年7月，平台月活跃用户数正式突破5000万大关。这一里程碑标志着传媒在线观看已经成为中文互联网用户首选的在线视频观看平台之一。',
    content: `<p>传媒在线观看平台宣布，截至2026年7月，平台月活跃用户数正式突破5000万大关。</p>
    <h2>增长动力</h2>
    <p>平台用户规模的快速增长得益于多方面因素的共同推动。丰富的内容品类、高清流畅的播放体验、智能化的内容推荐算法，以及无需下载、打开即看的便捷使用方式，都是吸引用户的重要原因。</p>
    <h2>用户画像</h2>
    <p>数据显示，传媒在线观看的用户覆盖了从18岁到55岁的广泛年龄层，其中25-40岁的中青年用户占比最高，达到总用户的58%。用户地域分布方面，一线城市和新一线城市用户合计占比超过65%。</p>
    <p>未来，传媒在线观看将继续加大在内容版权、技术研发和用户体验方面的投入。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20data%20dashboard%20showing%20user%20growth%20metrics%20and%20analytics%20charts%2C%20clean%20corporate%20style%2C%20warm%20professional%20lighting%2C%20business%20success%20visualization%2C%20growth%20and%20achievement%20theme&width=1200&height=675&seq=article-growth-07&orientation=landscape',
    date: '2026-07-28',
    author: '平台资讯',
    views: 28900,
    tags: ['用户增长', '平台数据', '里程碑'],
    featured: true,
  },
  {
    id: 'article-8',
    title: '相声专场"欢笑之夜"独家直播，德云社倾情献艺',
    category: 'zongyi',
    categoryName: '综艺娱乐',
    excerpt: '传媒在线观看平台将于本周末独家直播"欢笑之夜"相声专场演出。德云社众多知名相声演员将齐聚一堂，为线上观众带来一场精彩绝伦的相声盛宴。',
    content: `<p>传媒在线观看平台将于本周末独家直播"欢笑之夜"相声专场演出。德云社众多知名相声演员将齐聚一堂。</p>
    <h2>演出阵容</h2>
    <p>本次专场汇聚了德云社多位当红相声演员，包括郭德纲、于谦领衔，岳云鹏、孙越、张云雷等实力派演员悉数登场。经典段子重新演绎，新作品首次亮相，笑料不断、精彩纷呈。</p>
    <h2>直播互动</h2>
    <p>传媒在线观看平台为本次直播特别设置了"笑声弹幕"功能，观众发送的弹幕将以特殊的动画效果呈现，让线上观看的氛围更加热烈。同时，观众可以通过点赞和投票功能，选出本场最受欢迎的相声段子。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20theater%20stage%20with%20red%20curtains%20and%20warm%20spotlight%2C%20comedy%20performance%20venue%2C%20classic%20Chinese%20stage%20design%20with%20golden%20decorations%2C%20festive%20and%20joyful%20atmosphere&width=1200&height=675&seq=article-comedy-08&orientation=landscape',
    date: '2026-07-26',
    author: '综艺快报',
    views: 36700,
    tags: ['相声', '德云社', '直播'],
    featured: false,
  },
];

export const faqData = [
  {
    question: '传媒在线观看是否需要下载安装？',
    answer: '完全不需要！传媒在线观看是一个纯网页端的视频平台，您只需要使用浏览器打开网站，即可立即观看海量高清视频内容，无需下载任何软件或插件，真正做到"打开即看"。',
  },
  {
    question: '传媒在线观看支持哪些设备？',
    answer: '传媒在线观看全面支持PC电脑、平板电脑、智能手机等多种设备。无论是在办公室的电脑上，还是在家里的平板或手机上，您都可以随时随地畅享高清视频内容。我们的响应式设计会自动适配不同屏幕尺寸，确保最佳观看体验。',
  },
  {
    question: '传媒在线观看的视频画质如何？',
    answer: '传媒在线观看平台提供从标清到超高清的多种画质选择，最高支持4K超高清画质。系统会根据您的网络状况自动选择最佳画质，您也可以手动调整画质设置，以获得最流畅的观看体验。',
  },
  {
    question: '如何找到我想看的内容？',
    answer: '传媒在线观看提供多种内容发现方式：您可以通过首页的分类导航浏览不同品类的内容，使用搜索功能直接查找您想要的节目，或者让我们的智能推荐系统根据您的观看偏好为您推荐个性化内容。',
  },
  {
    question: '传媒在线观看的直播内容可以回看吗？',
    answer: '可以的！传媒在线观看平台提供完善的直播回看功能。大多数直播节目在播出后都会自动保存为回看内容，您可以在方便的时间随时观看。每个节目的回看有效期通常为7-30天，具体以节目页面显示的为准。',
  },
  {
    question: '传媒在线观看是否免费？',
    answer: '传媒在线观看提供大量免费的高清视频内容，包括新闻资讯、综艺节目、纪录片等。部分独家内容和超高清画质可能需要会员服务。我们致力于为每一位用户提供最优质的免费在线观看体验。',
  },
];